import { apiFetch } from '$lib/api/helpers';
import type { RCUAssignUnitRequest, RCURequest, RCUResponse } from '$lib/types/rcu';

const PATH = '/rcus/';

export async function fetchRCUs() {
	return apiFetch<Array<RCUResponse>>(PATH);
}

export async function fetchRCUById(id: number) {
	return apiFetch<RCUResponse>(`${PATH}${id}/`);
}

export async function createRCU(rcuRequest: RCURequest) {
	return apiFetch<RCUResponse>(PATH, {
		method: 'POST',
		body: JSON.stringify(rcuRequest)
	});
}

export async function deleteRCU(id: number) {
	return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}

export async function updateRCU(id: number, rcuRequest: Partial<RCURequest>) {
	return apiFetch<RCUResponse>(`${PATH}${id}/`, {
		method: 'PATCH',
		body: JSON.stringify(rcuRequest)
	});
}

export const patchRCU = updateRCU;

export async function assignUnit(id: number, unit: number | null) {
	return apiFetch<RCUResponse>(`${PATH}${id}/assign_unit/`, {
		method: 'POST',
		body: JSON.stringify({ unit } satisfies RCUAssignUnitRequest)
	});
}
